import React, { useEffect, useRef } from 'react';
import { createOptionsChart, HistogramSeries } from 'lightweight-charts';

const HistogramChart = ({ data, title }) => {
  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (!chartContainerRef.current || !data || data.length === 0) return;

    const chart = createOptionsChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: 300,
      layout: {
        backgroundColor: '#1a1e26',
        textColor: '#d1d5db',
      },
      grid: {
        vertLines: {
          color: 'rgba(70, 130, 180, 0.5)',
        },
        horzLines: {
          color: 'rgba(70, 130, 180, 0.5)',
        },
      },
    });

    const histogramSeries = chart.addSeries(HistogramSeries, {
      color: '#26a69a',
      priceFormat: {
        type: 'volume',
      },
    });

    // Assuming the data is an array of numbers, we need to format it for the histogram.
    // The lightweight-charts histogram expects data in the format: { time, value, color? }
    // We need to aggregate the data into bins.
    const binSize = (Math.max(...data) - Math.min(...data)) / 20; // Example: 20 bins
    const bins = {};
    data.forEach(value => {
      const bin = Math.floor(value / binSize) * binSize;
      bins[bin] = (bins[bin] || 0) + 1;
    });

    const histogramData = Object.keys(bins).map(key => ({
      time: parseFloat(key),
      value: bins[key],
    })).sort((a, b) => a.time - b.time);

    histogramSeries.setData(histogramData);

    chart.timeScale().fitContent();

    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
    };
  }, [data]);

  return (
    <div className="mt-4 p-3 bg-backgroundBody rounded shadow">
      <h3 className="text-lg font-semibold mb-2 text-textPrimary">{title}</h3>
      <div ref={chartContainerRef} />
    </div>
  );
};

export default HistogramChart;
